<template>
  <div class="upload-failure-view">
    <p>
      <span class="text-latin">
        {{ $t('DROPPABLE_UPLOADER.ERROR_IN_FILE', { fileName }) }}:
      </span>
      <span>{{ message }}</span>
    </p>

    <p v-for="error in errors" :key="error" class="text-small text-danger">
      {{ error }}
    </p>

    <ElButton
      type="primary"
      size="mini"
      icon="el-icon-refresh"
      @click.stop="$emit('retry')"
    >
      {{ $t('RETRY') }}
    </ElButton>

    <ElButton
      type="danger"
      plain
      size="mini"
      icon="el-icon-close"
      @click.stop="$emit('cancel')"
    >
      {{ $t('CANCEL') }}
    </ElButton>
  </div>
</template>

<script>
export default {
  name: 'UploadFailureView',
  props: {
    fileName: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      default: '',
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
